import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Shield, CheckCircle, XCircle, Loader2 } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminBypass() {
  const { user, code } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [message, setMessage] = useState('');
  const [bypassToken, setBypassToken] = useState('');

  useEffect(() => {
    const verifyBypass = async () => {
      try {
        const response = await axios.get(`${API}/admin/bypass/${user}/${code}`);
        setStatus('success');
        setMessage(response.data.message);
        setBypassToken(response.data.bypass_token);
        
        // Store bypass token in cookie
        document.cookie = `ip_bypass_token=${response.data.bypass_token}; path=/; max-age=86400`;
        
        // Also store in localStorage for axios
        localStorage.setItem('ip_bypass_token', response.data.bypass_token);
        
        // Set default header for axios
        axios.defaults.headers.common['x-bypass-token'] = response.data.bypass_token;
        
      } catch (error) {
        setStatus('error');
        setMessage(error.response?.data?.detail || 'Invalid bypass token');
      }
    };

    if (user && code) {
      verifyBypass();
    }
  }, [user, code]);

  const handleContinue = () => {
    navigate('/login');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4" data-testid="admin-bypass-page">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mb-4">
            <Shield className="w-8 h-8 text-primary" />
          </div>
          <CardTitle className="text-2xl">Admin Bypass</CardTitle>
          <CardDescription>IP Restriction Override</CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          {status === 'loading' && (
            <div className="text-center py-8">
              <Loader2 className="w-8 h-8 animate-spin mx-auto text-primary mb-4" />
              <p className="text-muted-foreground">Verifying bypass token...</p>
            </div>
          )}

          {status === 'success' && (
            <div className="text-center py-4">
              <div className="mx-auto w-12 h-12 rounded-full bg-green-500/10 flex items-center justify-center mb-4">
                <CheckCircle className="w-6 h-6 text-green-500" />
              </div>
              <h3 className="text-lg font-semibold text-green-600 mb-2">Access Granted</h3>
              <p className="text-muted-foreground mb-6">{message}</p>
              <Button onClick={handleContinue} className="w-full">
                Continue to Login
              </Button>
            </div>
          )}

          {status === 'error' && (
            <div className="text-center py-4">
              <div className="mx-auto w-12 h-12 rounded-full bg-red-500/10 flex items-center justify-center mb-4">
                <XCircle className="w-6 h-6 text-red-500" />
              </div>
              <h3 className="text-lg font-semibold text-red-600 mb-2">Access Denied</h3>
              <p className="text-muted-foreground">{message}</p>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
